import React from 'react';
import ButtonDesigned from './Buttons/ButtonDesigned';
import { useNavigate } from 'react-router-dom';

interface Props {
  title?: string;
  text?: string;
  closeFunction?: () => void;
  closeFunctionText?: string;
}

export const PendingScreen: React.FC<Props> = ({
  closeFunction,
  closeFunctionText = 'Close',
  text = 'The request was successfully submitted and is currently pending and waiting for approval.',
  title = 'Your request is submitted and pending',
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center  flex-1 ">
      <div className="flex flex-col items-center  gap-4 p-4">
        <img className="h-[5.5rem] w-[5.5rem]" src="/assets/icons/red/hourglass.svg" alt="Hourglass" />
        <p className="text-lg font-semibold text-center">{title}</p>
        <p className="max-w-[25rem] text-center">{text}</p>
        <ButtonDesigned
          style="outline"
          className="py-2 px-4"
          onButtonClick={closeFunction ? () => closeFunction() : () => navigate('/dashboard')}
        >
          {closeFunctionText}
        </ButtonDesigned>
      </div>
    </div>
  );
};
